// extracted by mini-css-extract-plugin
export default {"modalWrapper":"ModalWithButton_modalWrapper__Kqhc-","content":"ModalWithButton_content__r7yak","header":"ModalWithButton_header__GyiiK","body":"ModalWithButton_body__gU-EF"};